import type { AnyPayload } from '@post-office/message-template-contracts/placement-v2';

/** Pass through payloads for frontend stages that do not require validation. */
export const noValidation =
	<T = AnyPayload>(_valueWithType?: T): ((input: unknown) => T) =>
	(input) =>
		input as T;
